import { __decorate } from "tslib";
import { InputTextInstruction } from '@common/instructions/frontend-shared';
import { FrontendFeaturePlugin, provideFeatureAddonRoutes } from '@core/frontend-shared';
import { ClassName } from '@core/shared/class-name';
import { VirtualPropertyHelper } from '@core/shared/virtual-properties';
import * as i0 from "@angular/core";
let MpfUsersFrontendAdminFeature = /*#__PURE__*/(() => {
  let MpfUsersFrontendAdminFeature = class MpfUsersFrontendAdminFeature extends FrontendFeaturePlugin {
    getFeatureContext() {
      return {"package":"@mpf/users/frontend-admin","featureId":"mpf-users"};
    }
    getFeatureFunctionality(functionality) {
      functionality.defineMenuItems({
        adminToolbar: [{
          displayInGroup: 'statistics',
          routerLink: 'statistics/companies',
          label: 'Unternehmensübersicht',
          icon: 'building',
          priority: 5
        }]
      });
      functionality.defineModelInstructions([{
        modelId: 'CompanyItem',
        // displayContext:[ 'admin', 'crud' ],
        displayForEditorDefinitions: ['admin-general'],
        // displayInEditModes:['edit'] as ItemEditMode[],
        targetSlotId: 'main',
        instructions: [new InputTextInstruction({
          formControlName: VirtualPropertyHelper.accessor('customerId'),
          label: 'Kundennummer (Alt)',
          help: "Die Kundennummer ist dem Rechnungssystem zu entnehmen. " + "Hierüber wird das Unternehmens-Profil mit den entsprechenden Kundendaten/Rechnungsstellungen verknüpft."
        }), new InputTextInstruction({
          formControlName: VirtualPropertyHelper.accessor('contact_name'),
          label: 'Ansprechpartner'
        }), new InputTextInstruction({
          formControlName: VirtualPropertyHelper.accessor('contact_phone'),
          label: 'Ansprechpartner Telefonnr.'
        }), new InputTextInstruction({
          formControlName: VirtualPropertyHelper.accessor('contact_email'),
          label: 'Ansprechpartner E-Mail-Adresse'
        }), new InputTextInstruction({
          formControlName: VirtualPropertyHelper.accessor('invoicing_address'),
          label: 'Abw. Rechnungsadresse'
        })]
      }]);
      functionality.defineRouterLinkRedirects([{
        matcher: '/statistics',
        redirect: '/statistics/companies',
        type: 'Redirect'
      }]);
    }
    static {
      this.ɵfac = /*@__PURE__*/(() => {
        let ɵMpfUsersFrontendAdminFeature_BaseFactory;
        return function MpfUsersFrontendAdminFeature_Factory(__ngFactoryType__) {
          return (ɵMpfUsersFrontendAdminFeature_BaseFactory || (ɵMpfUsersFrontendAdminFeature_BaseFactory = i0.ɵɵgetInheritedFactory(MpfUsersFrontendAdminFeature)))(__ngFactoryType__ || MpfUsersFrontendAdminFeature);
        };
      })();
    }
    static {
      this.ɵmod = /*@__PURE__*/i0.ɵɵdefineNgModule({
        type: MpfUsersFrontendAdminFeature
      });
    }
    static {
      this.ɵinj = /*@__PURE__*/i0.ɵɵdefineInjector({
        providers: [provideFeatureAddonRoutes([{
          useAddonSlot: 'statistics',
          path: 'companies',
          loadChildren: () => import('./statistics/companies/companies-statistics.module').then(m => m.CompaniesStatisticsAdminModule)
        }])]
      });
    }
  };
  MpfUsersFrontendAdminFeature = __decorate([ClassName("MpfUsersFrontendAdminFeature")], MpfUsersFrontendAdminFeature);
  return MpfUsersFrontendAdminFeature;
})();
export { MpfUsersFrontendAdminFeature };